import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import {
  managedCompaniesSelector,
  companyDivisionsSelector,
  userCompaniesSelector,
} from '../Settings/store/SettingsSelectors'
import SignUpCodeAdmin, { ISignUpCodeAdminProps, ISignUpCodeAdminDispatchProps } from './SignUpCodeAdmin'
import {
  getCompanySignUpCodes,
  createCompanySignUpCode,
  updateCompanySignUpCode,
  deleteCompanySignUpCode,
} from './store/SignUpCodeAdminActions'
import {
  getSignUpCodes,
  getSignUpCodesLoading,
  getSignUpCodesCreating,
  getSignUpCodesUpdating,
  getSignUpCodesDeleting,
} from './store/SignUpCodeAdminSelectors'
import { getCompanyAdminSelectedCompanyId } from '../CompanyAdmin/store/CompanyAdminSelectors'
import { setCompanyAdminSelectedCompanyId } from '../CompanyAdmin/store/CompanyAdminActions'

const mapStateToProps = (state: IGlobalState): ISignUpCodeAdminProps => ({
  managedCompanies: managedCompaniesSelector(state),
  userCompanies: userCompaniesSelector(state),
  companyDivisions: companyDivisionsSelector(state),
  codes: getSignUpCodes(state),
  loading: getSignUpCodesLoading(state),
  creating: getSignUpCodesCreating(state),
  updating: getSignUpCodesUpdating(state),
  deleting: getSignUpCodesDeleting(state),
  selectedCompanyId: getCompanyAdminSelectedCompanyId(state),
})

const mapDispatchToProps: ISignUpCodeAdminDispatchProps = {
  getCompanySignUpCodes,
  createCompanySignUpCode,
  updateCompanySignUpCode,
  deleteCompanySignUpCode,
  setSignUpCodeSelectedCompanyId: setCompanyAdminSelectedCompanyId,
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUpCodeAdmin)
